import { Button, Flex, IconFont, Text } from '@byecode/ui'
import { differenceInDays, lightFormat } from 'date-fns'
import React, { useMemo } from 'react'
import styled from 'styled-components'

import { openSpaceGrade } from '../SpaceGrade'

const SCxAlert = styled(Flex)`
    position: relative;
    width: 100%;
    height: 58px;
    line-height: 58px;
    background-color: var(--color-theme-3);
    color: var(--color-theme-7);
    font-size: 14px;
`

const SCxGrade = styled.b`
    cursor: pointer;
    &:hover {
        opacity: 0.8;
    }
`

const SCxClose = styled(Button)`
    position: absolute;
    right: 10px;
    top: 50%;
    transform: translateY(-50%);
    cursor: pointer;
`

interface SpaceAlertProps {
    expiredAt: number | undefined
    onClose?: () => void
}

export const SpaceAlert: React.FC<SpaceAlertProps> = ({ expiredAt, onClose }) => {
    const diffDays = useMemo(() => {
        if (!expiredAt || expiredAt === -1) {
            return -1
        }
        return differenceInDays(expiredAt, Date.now())
    }, [expiredAt])

    const expiredDate = useMemo(() => {
        if (!expiredAt || expiredAt === -1) {
            return ''
        }
        return lightFormat(expiredAt, 'yyyy-MM-dd hh:mm')
    }, [expiredAt])

    if (diffDays === -1) {
        return null
    }

    return (
        <SCxAlert justifyContent="center">
            <Text>
                即将到期提醒：产品服务将在{' '}
                <b>
                    {diffDays} 天后（{expiredDate}） 到期
                </b>
                ，到期后将无法享受付费权益及服务，请及时续费版本{' '}
                <SCxGrade onClick={() => openSpaceGrade('version_upgrade')}>点击续费</SCxGrade>
            </Text>
            <SCxClose type="text" icon={<IconFont type="Close" size={16} fill="var(--color-theme-7)" />} onClick={onClose} />
        </SCxAlert>
    )
}
